import { Transform, Type } from 'class-transformer';
import {
  ArrayMaxSize,
  IsArray,
  IsBoolean,
  IsNotEmpty,
  IsNumber,
  IsOptional,
  IsString,
  Matches,
  Min,
  ValidateNested,
} from 'class-validator';

const MAX_DELIVERY_BATCH_ARRAY_SIZE = 200;

export class AddBatchItemValidationDto {
  @IsString()
  @IsNotEmpty()
  productName!: string;

  @IsNumber()
  @Transform(({ value }: { value: unknown }) =>
    value === '' || value === null ? undefined : Number(value),
  )
  quantity!: number;

  @IsString()
  @IsNotEmpty()
  unit!: string;

  @IsString()
  @IsNotEmpty()
  batchNumber!: string;

  @IsOptional()
  @IsString()
  expiryDate?: string;

  @IsOptional()
  @IsBoolean()
  hasNoExpiry?: boolean;

  @IsOptional()
  @IsBoolean()
  isDamaged?: boolean;

  @IsOptional()
  @IsBoolean()
  isTemperatureNonCompliant?: boolean;

  @IsOptional()
  @IsBoolean()
  isHygieneNonCompliant?: boolean;

  @IsOptional()
  @IsNumber()
  @Min(0)
  @Transform(({ value }: { value: unknown }) =>
    value === '' || value === null ? undefined : Number(value),
  )
  unitPrice?: number;

  @IsOptional()
  @IsNumber()
  @Min(0)
  @Transform(({ value }: { value: unknown }) =>
    value === '' || value === null ? undefined : Number(value),
  )
  lineTotal?: number;

  @IsOptional()
  @IsString()
  @Matches(/^[A-Z]{3}$/)
  currency?: string;
}

export class AddBatchItemsDto {
  @IsArray()
  @ArrayMaxSize(MAX_DELIVERY_BATCH_ARRAY_SIZE)
  @ValidateNested({ each: true })
  @Type(() => AddBatchItemValidationDto)
  items!: AddBatchItemValidationDto[];
}
